/**
 * Order Management — design tokens, filter tabs, and status constants.
 */

/** Order list source tabs (left → right). Restaurant → GetActiveOrders; Next day → GetNextDayPromoStoreOrders. */
export const ORDER_TYPE_RESTAURANT = 'restaurant';
export const ORDER_TYPE_NEXT_DAY_PROMOTION = 'next_day_promotion';
export const ORDER_TYPE_CLOUD_KITCHEN = 'cloud_kitchen';

export const DEFAULT_ORDER_TYPE_VIEW = ORDER_TYPE_RESTAURANT;

/** Next day promotion — day split tabs (no status filters). */
export const NEXT_DAY_PROMO_DAY_TODAY = 'today';
export const NEXT_DAY_PROMO_DAY_TOMORROW = 'tomorrow';

export const NEXT_DAY_PROMO_DAY_TABS = [
  { value: NEXT_DAY_PROMO_DAY_TODAY, label: 'Today' },
  { value: NEXT_DAY_PROMO_DAY_TOMORROW, label: 'Tomorrow' },
];

export const COLORS = {
  ink: '#111111',
  muted: '#8C8C8C',
  border: '#E8E8E8',
  rowDivider: '#F0F0F0',
  headerBg: '#F7F8FA',
  pageBg: '#F5F4F2',
  white: '#FFFFFF',
};

export const COLORS_NEXT_DAY_PROMO = {
  ink: '#EA580C',
  muted: '#C2440A',
  border: '#EDE5DC',          // near-neutral warm border — no colored edges on cards
  rowDivider: '#F5EDE5',
  headerBg: '#fffcfa',        // card header strip background — warm orange tint
  pageBg: '#FFFFFF',           // page + expanded accordion wrapper
  accordionBg: '#FFFFFF',
  white: '#FFFFFF',
  // Card header strip (the row with icon + title inside each card)
  cardHeaderBg: '#fffcfa',
  cardHeaderBorder: '#EDE0D4',
  // Order # badge in card header
  orderBadgeBg: '#FFEADB',
  orderBadgeText: '#C2440A',
  // Completed timeline dots
  completedDot: '#EA580C',
  completedDotText: '#FFFFFF',
  // Status-style tabs (underline + badges — same layout as Restaurant)
  activeTabBorder: '#EA580C',
  tabBadgeBg: '#EA580C',
  tabBadgeText: '#FFFFFF',
  inactiveTabBadgeBg: '#FFEDD5',
  inactiveTabBadgeText: '#C2440A',
};

export const STATUS_TABS = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'order accepted by kitchen', label: 'Accepted' },
  { value: 'order ready for pickup', label: 'Ready' },
  { value: 'driver pickup pending', label: 'Pickup Pending' },
  { value: 'driver picked the order', label: 'Driver Picked' },
  { value: 'driver is at the door', label: 'At the Door' },
  { value: 'order delivered', label: 'Delivered' },
  { value: 'order picked in store by customer', label: 'Picked in Store' },
  { value: 'order canceled by kitchen', label: 'Canceled (Kitchen)' },
  { value: 'order canceled by customer', label: 'Canceled (Customer)' },
  { value: 'order_unpicked_by_driver', label: 'Unpicked' },
  { value: 'order_damaged_while_delivery', label: 'Damaged' },
  { value: 'order canceled by computer no response from kitchen', label: 'No Response' },
];

/** Updatable statuses for Regional Branch manager actions panel. */
export const BRANCH_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending', color: '#D97706', bg: '#FFFBEB' },
  { value: 'order accepted by kitchen', label: 'Accepted', color: '#2563EB', bg: '#EFF6FF' },
  { value: 'order ready for pickup', label: 'Ready for pickup', color: '#7C3AED', bg: '#F5F3FF' },
  { value: 'driver pickup pending', label: 'Driver pickup pending', color: '#0891B2', bg: '#ECFEFF' },
  { value: 'driver picked the order', label: 'Driver picked', color: '#059669', bg: '#ECFDF5' },
  { value: 'driver is at the door', label: 'At the door', color: '#16A34A', bg: '#F0FDF4' },
  { value: 'order delivered', label: 'Delivered', color: '#166534', bg: '#DCFCE7' },
  { value: 'order picked in store by customer', label: 'Picked in store', color: '#0284C7', bg: '#F0F9FF' },
  { value: 'order canceled by kitchen', label: 'Cancel (Kitchen)', color: '#DC2626', bg: '#FEF2F2' },
  { value: 'order canceled by customer', label: 'Cancel (Customer)', color: '#DC2626', bg: '#FEF2F2' },
];

export const ORDER_STATUS_SEQUENCE = [
  'pending',
  'order accepted by kitchen',
  'order ready for pickup',
  'driver pickup pending',
  'driver picked the order',
  'driver is at the door',
  'order delivered',
];

export const PICKUP_IN_STORE_SEQUENCE = [
  'pending',
  'order accepted by kitchen',
  'order ready for pickup',
  'order picked in store by customer',
];

export const TERMINAL_TRACKING_STATUSES = [
  'order canceled by kitchen',
  'order canceled by customer',
  'order canceled by computer no response from kitchen',
  'order_unpicked_by_driver',
  'order_damaged_while_delivery',
];

export const TERMINAL_STATUSES = new Set([
  'order delivered',
  'order canceled by kitchen',
  'order canceled by customer',
  'order_unpicked_by_driver',
  'order_damaged_while_delivery',
  'order picked in store by customer',
  'order canceled by computer no response from kitchen',
]);
